<template>
  <v-form ref="form">
    <v-row justify="center" style="display: none">
      <v-dialog v-model="dialog" persistent max-width="512">
        <v-card id="user-layers__card">
          <v-card-title class="headline">{{ title }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col xs="12" class="py-0">
                <v-text-field
                  outlined
                  v-model="layer.name_pl"
                  :label="$i18n.t('settings.polishLayerName')"
                  :rules="nameRules"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col xs="12" class="py-0">
                <v-text-field
                  outlined
                  v-model="layer.name_en"
                  :label="$i18n.t('settings.englishLayerName')"
                  :rules="nameRules"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-row no-gutters style="min-height: 400px">
            <layer-style
              class="mt-4 pl-5 pr-6"
              :geometry-type="computedLayer.geometry_type"
              :layer-attributes="computedLayer.fields"
              :layer-id="computedLayer.id"
              :layer-style.sync="computedLayer.style"
              :is-style-valid.sync="isStyleValid"
            />
          </v-row>
          <v-card-actions>
            <div class="flex-grow-1" />
            <v-btn color="primary" text @click="cancel">{{ $i18n.t('default.cancel') }}</v-btn>
            <v-btn
              color="primary"
              text
              @click="success"
              :disabled="!isStyleValid"
            >{{ $i18n.t('default.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-form>
</template>
<script>
export default {
  components: {
    LayerStyle: () => import('@/components/settings/LayerStyle')
  },
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    layer: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    isStyleValid: false
  }),
  computed: {
    computedLayer: {
      get() {
        return this.layer;
      },
      set(nV) {
        this.$emit('update:layer', nV);
      }
    },
    nameRules() {
      return [value => !!value || this.$i18n.t('default.requiredField')];
    },
    title() {
      const name = this.$i18n.locale === 'pl' ? this.layer.name_pl : this.layer.name_en;
      return this.$i18n.t('settings.editUserLayerSettings') + ': ' + name;
    }
  },
  methods: {
    success() {
      this.$emit('success');
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>
<style lang="scss">
#opacity-settings--edit {
  position: absolute;
  top: 380px !important;
}
#opacity-settings-column {
  .v-input__slider {
    position: absolute;
    top: 400px;
    width: 230px;
  }
  .v-slider {
    margin-left: 0;
  }
}
.v-input__slider {
  margin-top: 15px;
}
</style>